import { Grid, Paper } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/system";
import { useAppSelector } from "../../app/store/configureStore";
import React from "react";
import { SummaryDto } from "../../app/models/pcs/summaryDto";

const useStyles = makeStyles(() => ({
    root: {
        "& .MuiPaper-root": {
            width: "unset",
            marginLeft: "0"
        }
    },
    alignCenter: {
        textAlign: 'center'
    },
    gridItem: {
        textAlign: 'center',
        paddingTop: '16px'
    }
}));

interface Props {
    legacySixYearSummaryData: SummaryDto[][] | null;
    isLegacyYearPartialyCompleted: boolean;
}

export default function LegacySummaryTable({ legacySixYearSummaryData, isLegacyYearPartialyCompleted }: Props) {
    const { legacyTitles } = useAppSelector(state => state.pcs);

    const classes = useStyles();

    const GetSummaryColorCode = (colorName: string) => {
        switch (colorName.toUpperCase()) {
            case "RED":
                return '#d64b5f';
            case "AMBER":
                return "#e46c0a";
            case "GREEN":
                return "#00af66";
            case "WHITE":
                return "#FFFFFF";
            default:
                return "#FFFFFF";
        }
    }

    return <Box sx={{ flexGrow: 1, padding: 2 }} component={Paper} className={classes.root}>

        <Grid container columns={24}>
            <Grid item display={{ xs: 'block' }} xs={8} sm={2} className={classes.alignCenter}>
                <b>{legacyTitles === null ? '' : legacyTitles[0]}</b>
            </Grid>

            <Grid item display={{ xs: 'none', sm: 'block' }} sm={3} className={classes.alignCenter}>
                <b>{legacyTitles === null ? '' : legacyTitles[2]}</b>
            </Grid>
            
            <Grid item display={{ xs: 'none', sm: 'block' }} sm={3} className={classes.alignCenter}>
                <b>{legacyTitles === null ? '' : legacyTitles[3]}</b>
            </Grid>
            
            <Grid item display={{ xs: 'none', sm: 'block' }} sm={3} className={classes.alignCenter}>
                <b>{legacyTitles === null ? '' : legacyTitles[4]}</b>
            </Grid>
            
            <Grid item display={{ xs: 'none', sm: 'block' }} sm={3} className={classes.alignCenter}>
                <b>{legacyTitles === null ? '' : legacyTitles[5]}</b>
            </Grid>
            
            <Grid item display={{ xs: 'none', sm: 'block' }} sm={3} className={classes.alignCenter}>
                <b>{legacyTitles === null ? '' : legacyTitles[6]}</b>
            </Grid>

            <Grid item display={{ xs: 'none', sm: 'block' }} sm={3} className={classes.alignCenter}>
                <b>{legacyTitles === null ? '' : legacyTitles[7]}</b>
            </Grid>

            <Grid item display={{ xs: 'block', sm: 'none' }} xs={4}></Grid>

            <Grid item display={{ xs: 'block' }} xs={12} sm={1.5} className={classes.alignCenter}>
                <b>{legacyTitles === null ? '' : legacyTitles[8]}</b>
            </Grid>

            <Grid item display={{ xs: 'none', sm: 'block' }} sm={2} className={classes.alignCenter}>
                <b>{legacyTitles === null ? '' : legacyTitles[9]}</b>
            </Grid>

            {legacySixYearSummaryData?.map((item: SummaryDto[], index: number) => (
                <React.Fragment key={index}>

                    <Grid item xs={8} sm={2}>
                        <Grid display={{ xs: 'block' }} className={classes.gridItem}>
                            {item[0].text}
                            {item[1].text.toLowerCase() === "true" ? "*" : ""}
                        </Grid>
                    </Grid>

                    <Grid item display={{ xs: 'none', sm: 'block' }} sm={3} sx={{ padding: 1 }}>
                        <Grid sx={{
                            backgroundColor: GetSummaryColorCode(item[2].status.toUpperCase()),
                            textAlign: 'center', padding: 1
                        }}><b>{item[2].text.split('(')[0]}</b>({item[2].text.split('(')[1]}</Grid>
                    </Grid>

                    <Grid item display={{ xs: 'none', sm: 'block' }} sm={3} sx={{ padding: 1 }}>
                        <Grid sx={{
                            backgroundColor: GetSummaryColorCode(item[3].status.toUpperCase()),
                            textAlign: 'center', padding: 1
                        }}><b>{item[3].text.split('(')[0]}</b>({item[3].text.split('(')[1]}</Grid>
                    </Grid>

                    <Grid item display={{ xs: 'none', sm: 'block' }} sm={3} sx={{ padding: 1 }}>
                        <Grid sx={{
                            backgroundColor: GetSummaryColorCode(item[4].status.toUpperCase()),
                            textAlign: 'center', padding: 1
                        }}><b>{item[4].text.split('(')[0]}</b>({item[4].text.split('(')[1]}</Grid>
                    </Grid>

                    <Grid item display={{ xs: 'none', sm: 'block' }} sm={3} sx={{ padding: 1 }}>
                        <Grid sx={{
                            backgroundColor: GetSummaryColorCode(item[5].status.toUpperCase()),
                            textAlign: 'center', padding: 1
                        }}><b>{item[5].text.split('(')[0]}</b>({item[5].text.split('(')[1]}</Grid>
                    </Grid>

                    <Grid item display={{ xs: 'none', sm: 'block' }} sm={3} sx={{ padding: 1 }}>
                        <Grid sx={{
                            backgroundColor: GetSummaryColorCode(item[6].status.toUpperCase()),
                            textAlign: 'center', padding: 1
                        }}><b>{item[6].text.split('(')[0]}</b>({item[6].text.split('(')[1]}</Grid>
                    </Grid>

                    <Grid item display={{ xs: 'none', sm: 'block' }} sm={3} sx={{ padding: 1 }}>
                        <Grid sx={{
                            backgroundColor: GetSummaryColorCode(item[7].status.toUpperCase()),
                            textAlign: 'center', padding: 1
                        }}>{item[7].text}</Grid>
                    </Grid>

                    <Grid item display={{ xs: 'block', sm: 'none' }} xs={4}></Grid>

                    <Grid item display={{ xs: 'block' }} xs={12} sm={1.5} sx={{ padding: 1 }}>
                        <Grid sx={{
                            backgroundColor: GetSummaryColorCode(item[8].status.toUpperCase()),
                            textAlign: 'center', padding: 1
                        }}>{item[8].text}</Grid>
                    </Grid>

                    <Grid item display={{ xs: 'none', sm: 'block' }} sm={2}>
                        <Grid className={classes.gridItem}>{item[9].text}</Grid>
                    </Grid>
                </React.Fragment>
            ))}

            {legacySixYearSummaryData?.length === 0 &&
                <Grid item xs={12} sx={{ textAlign: 'center', padding: 5 }}>No records found.</Grid>
            }

            {legacySixYearSummaryData && legacySixYearSummaryData?.length > 0 && <>
                {isLegacyYearPartialyCompleted === true &&
                    <Grid item xs={24} sx={{ paddingTop: 2 }}>* Partial Year Completed.</Grid>
                }

                <Grid item xs={24} sx={{ paddingTop: 2, textAlign: 'start' }}>
                    Note: CPD Category requirements are displayed in brackets.
                </Grid>

                <Grid item xs={24} sx={{ paddingTop: 2, textAlign: 'start' }}>
                    <b>Please note: (Req.) = Required  - (Not Req.) =  Not Required.</b>
                </Grid>
            </>}
        </Grid>
    </Box>
}